import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase-config";


export const saveTransaction = async ({ type, direction, uid, amount, itemId, proofUrls, reason }) => {
  try {
    const now = new Date();


    // transactions/<autoId>
// {
//   type: "student_payment" | "admin_payout",    // NEW: classify
//   direction: "credit" | "debit",               // credit to platform, debit from platform
//   toUid: string | null,                        // for payouts, who is being paid
//   fromUid: string | null,                      // admin uid (optional)
//   amount: number,
//   month: number,                                // 1..12 (for reporting)
//   year: number,                                 // YYYY
//   proofUrl: string,                             // uploaded SS
//   reason: string,                               // e.g. "Monthly payout Aug 2025"
//   status: "completed" | "pending" | "failed",   // manual bookkeeping
//   createdAt: serverTimestamp(),
//   createdAtStr: "DD-MM-YY HH:mm:ss"             // if you want your formatted string too
// }

    const transactionData = {
      type,
      direction,
      uid,
      amount,
      itemId,
      proofUrls,
      reason,
      day: now.getDate(),
      month: now.getMonth() + 1,
      year: now.getFullYear(),
      createdAt: Timestamp.fromDate(now),
    };
    console.log("Transaction data",transactionData);
    

    await addDoc(collection(db, "transactions"), transactionData);

    console.log("Transaction saved successfully:", transactionData);
  } catch (error) {
    console.error("Error saving transaction:", error);
    throw error;
  }
};




export const savePayment = async ({ uid, amount, itemId, proofUrls, reason }) => {
  try {
    const now = new Date();

    const transactionData = {
      uid,
      amount,
      itemId,
      proofUrls,
      reason,
      day: now.getDate(),
      month: now.getMonth() + 1,
      year: now.getFullYear(),
      createdAt: Timestamp.fromDate(now),
    };

    const userPaymentRef = collection(db, `users/${uid}/payment`);
    await addDoc(userPaymentRef, transactionData);

    console.log("Transaction saved successfully:", transactionData);
  } catch (error) {
    console.error("Error saving transaction:", error);
    throw error;
  }
};


